import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Ticket } from "lucide-react";
import EmptyState from "@/components/common/EmptyState";
import EventoBoletosCard from "@/components/common/EventoBoletosCard";
import {
  agruparComprasPorEvento,
  hidratarComprasBoletos,
} from "@/data/comprasStore";
import { getCurrentSocio } from "@/data/socioAuthStore";
import { SCREENS, MIS_BOLETOS } from "@/constants/testIds";

export default function MisBoletos() {
  const navigate = useNavigate();
  const socio = useMemo(() => getCurrentSocio(), []);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    hidratarComprasBoletos().then(() => setTick((t) => t + 1));
  }, []);
  // Sprint 54 · Fase A: una sola tarjeta por eventoId (agrupación de
  // presentación; el backend conserva las compras separadas).
  const grupos = useMemo(
    () => (socio ? agruparComprasPorEvento(socio.id) : []),
    [socio, tick],
  );

  return (
    <div data-testid={SCREENS.misBoletos} className="flex flex-col gap-8 pb-24">
      <header className="animate-fade-up">
        <span className="overline text-accent">Mis Boletos</span>
        <h1 className="mt-3 font-heading text-3xl sm:text-4xl tracking-tight text-foreground">
          Tus experiencias
        </h1>
        <p className="mt-3 text-muted-foreground max-w-md leading-relaxed">
          Aquí verás los boletos y accesos a los eventos del Casino Tampiqueño
          en los que participarás.
        </p>
      </header>

      {grupos.length === 0 ? (
        <div className="animate-fade-up delay-100">
          <EmptyState
            icon={Ticket}
            eyebrow="Sin boletos"
            title="Aún no tienes boletos."
            description="Cuando compres boletos para un evento, aparecerán aquí."
            testId={MIS_BOLETOS.emptyState}
            action={
              <button
                type="button"
                data-testid={MIS_BOLETOS.btnVerEventos}
                onClick={() => navigate("/app")}
                className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-medium bg-primary text-primary-foreground dark:bg-accent dark:text-accent-foreground ring-1 ring-primary/20 dark:ring-accent/40 shadow-soft hover:opacity-90 transition-opacity"
              >
                Ver eventos
              </button>
            }
          />
        </div>
      ) : (
        <section
          data-testid={MIS_BOLETOS.list}
          className="grid grid-cols-1 md:grid-cols-2 gap-5 animate-fade-up delay-100"
        >
          {grupos.map((g) => (
            <EventoBoletosCard
              key={g.eventoId}
              grupo={g}
              onAdministrar={() =>
                navigate(`/app/eventos/${g.eventoId}/asignar`, {
                  state: { from: "/app/mis-boletos" },
                })
              }
              onVerDetalles={() =>
                navigate(`/app/eventos/${g.eventoId}/mis-compras`, {
                  state: { from: "/app/mis-boletos" },
                })
              }
            />
          ))}
        </section>
      )}
    </div>
  );
}
